export function selectKeys(object, keys) {
    return keys.reduce((o, k) => {
        o[k] = object[k];
        return o;
    }, {});
}

export function objectToArray(object) {
    if (object) {
        return Object.keys(object).map(k => object[k]);
    }
    return [];
}

export function flatten(list) {
    return list.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);
}

export function lastIndex(array, cond) {
    if (!array.length) return -1;
    if (!cond) return array.length - 1;

    for (let i = array.length - 1; i >= 0; --i) {
        if (cond(array[i])) return i;
    }

    return -1;
}

export function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = arr1.length; i--; ) {
        if (arr1[i] !== arr2[i]) return false;
    }

    return true;
}

export function objectsEqual(a, b) {
    if (a == null && b == null) {
        return true;
    }

    if (a == null || b == null) {
        return false;
    }
    // Create arrays of property names
    const aProps = Object.getOwnPropertyNames(a);
    const bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length !== bProps.length) {
        return false;
    }

    for (let i = 0; i < aProps.length; i++) {
        const propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    // If we made it this far, objects
    // are considered equivalent
    return true;
}

export function removeItem(arr, item) {
    const idx = arr.indexOf(item);
    if (idx > -1) {
        return [...arr.slice(0, idx), ...arr.slice(idx + 1)];
    }
    return arr;
}
